module.exports = __webpack_public_path__ + "media/images/sp/stores/yokohama/yokohama_sns_01-48280367703d8b7abd9a1f530eac5933.jpg";